import { Inject, Injectable } from "@angular/core";
import { Cookie, CookieService } from "@obg/ngx.global";
import { LoggingFactory } from "@obg/ngx.global.evo";
import { CookieOptions, Request, Response } from "express";
import { isNil } from "lodash-es";

import { REQUEST_TOKEN, RESPONSE_TOKEN } from "../model";

@Injectable()
export class ServerCookieService extends CookieService {
	constructor(
		logging: LoggingFactory,
		@Inject(REQUEST_TOKEN) public request: Request,
		@Inject(RESPONSE_TOKEN) private response: Response
	) {
		super(logging);
	}

	get(name: string): string | undefined {
		const cookie = this.getCookieRegExp(name).exec(this.request.headers.cookie as string);

		if (isNil(cookie)) {
			return undefined;
		}
		try {
			return decodeURIComponent(cookie[1]);
		} catch {
			return undefined;
		}
	}

	set(cookie: Cookie) {
		let responseOptions: CookieOptions = {
			expires: cookie.expiryDate,
			secure: cookie.secure,
		};

		if (!cookie.isSubdomainSpecific) {
			responseOptions = {
				domain: this.request.hostname.replace(/^www(.*?)\./, ""),
				...responseOptions,
			};
		}

		this.response.cookie(cookie.name, cookie.value, responseOptions);
	}

	delete(name: string) {
		this.response.clearCookie(name);
	}

	getAll(predicate?: (key: string) => boolean): Record<string, string> | undefined {
		if (!this.request.headers || !this.request.headers.cookie) {
			return undefined;
		}

		const pairs = (this.request.headers.cookie as string).split(";");
		const cookies: Record<string, string> = {};

		for (const pair of pairs) {
			const [key, value] = pair.split("=");
			if (predicate && !predicate(key)) {
				continue;
			}

			try {
				cookies[key.trim()] = decodeURIComponent(value);
			} catch {
				// skip
			}
		}

		return cookies;
	}
}
